import { render, staticRenderFns } from "./edc-submitted-form.vue?vue&type=template&id=a63e1bbe&scoped=true&"
import script from "./edc-submitted-form.vue?vue&type=script&lang=js&"
export * from "./edc-submitted-form.vue?vue&type=script&lang=js&"
import style0 from "./edc-submitted-form.vue?vue&type=style&index=0&id=a63e1bbe&scoped=true&lang=scss&"
import style1 from "./edc-submitted-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63e1bbe",
  null
  
)

component.options.__file = "edc-submitted-form.vue"
export default component.exports